// extracted by mini-css-extract-plugin
export default {"weatherContainer":"WeatherDisplay_weatherContainer__DaokF","temperature":"WeatherDisplay_temperature__ndafE","weatherDescription":"WeatherDisplay_weatherDescription__6yRrZ"};